import PropTypes from "prop-types";
import TextOverflowFade from "../TextOverflowFade";
import styles from "./index.css";

const ProductTitle = ({ labelledById, title }) => (
  <div id={labelledById} className={styles.productTitle} aria-hidden={true}>
    <TextOverflowFade text={title} />
  </div>
);

ProductTitle.propTypes = {
  labelledById: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

export default ProductTitle;
